import { render, staticRenderFns } from "./ColumnDetail.vue?vue&type=template&id=703bfe4a&scoped=true"
import script from "./ColumnDetail.vue?vue&type=script&lang=js"
export * from "./ColumnDetail.vue?vue&type=script&lang=js"
import style0 from "./ColumnDetail.vue?vue&type=style&index=0&id=703bfe4a&prod&lang=scss"
import style1 from "./ColumnDetail.vue?vue&type=style&index=1&id=703bfe4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703bfe4a",
  null
  
)

export default component.exports